import React from 'react';
import { Form, TextArea } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

const BigText = ({
                     value,
                     name,
                     onChange,
                     onBlur,
                     isDisabled,
                     noLabel,
                     className,
                     rows,
                     text,
                     isRequired,
                     error,
                 }) => {
    const { t } = useTranslation();

    const getClassNames = () => {
        const classNames = [];

        if (error) {
            classNames.push('input-error');
        }

        if (className) {
            classNames.push(className);
        }

        return classNames.join(' ');
    };

    return (
        <Form.Field>
            {!noLabel ? (
                <label className={isDisabled ? 'label-disabled' : null}>{`${t(text || name)}${
                    isRequired ? ' *' : ''
                    }`}</label>
            ) : null}
            <TextArea
                className={getClassNames()}
                autoHeight
                disabled={isDisabled || false}
                name={name}
                rows={rows}
                value={value || ''}
                onChange={onChange}
                //onChange={onBlur}
            />
            {error && typeof error === 'string' ? (
                <span className="label-error">{error}</span>
            ) : null}
        </Form.Field>
    );
};
export default BigText;
